import Swiper, { Pagination, EffectFade, } from 'swiper';
Swiper.use([Pagination, EffectFade]);

function initGallery() {
    const galleries = document.querySelectorAll('.js-gallery');
    galleries.forEach(item => {
        new Swiper(item, {
            slidesPerView: 'auto',
            // centeredSlides: true,
            spaceBetween: 20,
            pagination: {
                el: '.swiper-pagination',
                dynamicBullets: true,
            },
        });
    })


}

export default initGallery;